export type DocumentPickerOption = {
    filename: string;
    hashcode: string;
    score?: number;
    status?: string | number | null;
};

export type DocumentPickerPayload = {
    type: string;
    selectionMode?: string;
    originalQuestion: string;
    message: string;
    options: DocumentPickerOption[];
    maxSelect?: number;
    selectedHashcodes?: string[];
};

export type ChatAssistantMetadata = {
    type?: string;
    document_picker?: DocumentPickerPayload;
    document_selection?: {
        action: string;
        type?: string;
        selectionMode?: string;
        originalQuestion: string;
        documents: DocumentPickerOption[];
    };
    scope?: {
        type: string;
        documents: DocumentPickerOption[];
        expanded_to_full_collection?: boolean;
    };
};

export class ChatAssistantResponse {
    Question: string;
    Answer: string;
    OrderIndex: number;
    SourceUrl?: string | null;
    Pages?: number[] | null;
    ChatGptAnswer?: string | null;
    StreamingId?: string;
    IsChatGptLoading?: boolean;
    DocumentPicker?: DocumentPickerPayload | null;
    MetadataJson?: ChatAssistantMetadata | null;

    constructor(data: { Question: string; Answer: string, OrderIndex: number, SourceUrl?: string | null, Pages?: number[] | null, ChatGptAnswer?: string | null, StreamingId?: string, IsChatGptLoading?: boolean, DocumentPicker?: DocumentPickerPayload | null, MetadataJson?: ChatAssistantMetadata | null }) {
        this.Question = data.Question;
        this.Answer = data.Answer;
        this.OrderIndex = data.OrderIndex;
        this.SourceUrl = data.SourceUrl || null;
        this.Pages = data.Pages || null;
        this.ChatGptAnswer = data.ChatGptAnswer || null;
        this.StreamingId = data.StreamingId || undefined;
        this.IsChatGptLoading = data.IsChatGptLoading || false;
        this.DocumentPicker = data.DocumentPicker || null;
        this.MetadataJson = data.MetadataJson || null;
    }
}
